// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4c38eedc","952":"0484ee1f"}[chunkId] + ".chunk.js";
};